<div class="multi-select-container">
  <div class="container-esquerdo">
    <!-- <div class="options-container">
      <label class="label-texto">{{ title }}</label>
      <div class="novo-select" (click)="changeOptions()">
        <div class="select" id="select" name="texto" class="input-texto" required="required" aria-required="true">Selecione uma Opção</div>
          <i class="fas" [ngClass]="showOptions ? 'fa-chevron-up' : 'fa-chevron-down'" ></i>
        </div>
    </div> -->

    <div id="checkboxes" class="checkboxes" *ngIf="showOptions">
      <label  *ngFor="let item of list" class="checkbox-container" id="conectado-lista">
        {{ item.nome }}
        <input type="checkbox" id="conectado-select" [checked]="item.selected" (click)="onSelect($event, item)"   />
        <span id="conectado" class="checkmark checkmark-margen"></span>
        <span id="conectado-name" class="label-checkbox"></span>
      </label>
    </div>
  </div>

  <div class="span-titulo">
    <strong class="label-campo">Selecionados:</strong>
  </div>


  <div class="content-direito" *ngIf="selectedlist.length > 0">
    <div class="chip-container">
      <div *ngFor="let item of selectedlist" class="chip">
        <span class="label">{{ item.nome }}</span>
        <i class="far fa-times" name="delete" (click)="onValue(item)"></i>
      </div>
    </div>
  </div>
</div>

